import SelectComponent from "components/common/select";
import { useRef, useState, useEffect } from "react";
import { CaretRight, CaretDown, Trash } from "phosphor-react";
import RadioButton from "components/common/radio-button/RadioButton";
import { TaskAddSchema, TaskInitialValues } from "constants/history";
import { ErrorMessage, Formik } from "formik";
import Input from "components/common/input";
import DateInput from "components/common/date-picker";
import AsyncSelect from "components/common/select/AsyncSelect";
import debounce from "lodash/debounce";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import { getActiveUsers } from "containers/survey/api";
import moment from "moment";
import { disablePastDates } from "utils/common";
const useDebouncedFetchUsers = () => {
  const debouncedFetch = useRef(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getActiveUsers({
          search: inputValue,
        });
        let formattedOptions = response?.users?.map((el) => ({
          value: el.id,
          label: el.name,
        }));

        if (!formattedOptions || formattedOptions.length === 0) {
          callback([]);
        } else {
          callback(formattedOptions);
        }
      } catch (error) {
        console.error("Failed to fetch members:", error);
        callback([]);
      }
    }, DEBOUNCE_DELAY)
  ).current;

  return debouncedFetch;
};

const AddTaskForm = ({
  handleSubmittion,
  handleClose,
  currentTaskEdit,
  users,
}) => {
  const [usersList, setUsersList] = useState([]);
  const debouncedFetchUsersData = useDebouncedFetchUsers();
  const isEditMode = Boolean(currentTaskEdit);

  useEffect(() => {
    (async () => {
      const result = await getActiveUsers({
        ...initialMetaForTable,
        page: 1,
      });
      if (result?.users) setUsersList(result?.users);
    })();
  }, [debouncedFetchUsersData]);

  return (
    <Formik
      // to be fixed when APIs are completly  working
      initialValues={
        isEditMode
          ? {
              ...TaskInitialValues,
              ...currentTaskEdit,
              ...(currentTaskEdit.user && {
                user_id: currentTaskEdit.user.id,
                due_date: currentTaskEdit.due_date
                  ? moment(currentTaskEdit.due_date, "DD/MM/YYYY").format(
                      "MM/DD/YYYY"
                    )
                  : null,
              }),
            }
          : TaskInitialValues
      }
      validationSchema={TaskAddSchema}
      onSubmit={(values, { setSubmitting }) => {
        handleSubmittion(values, setSubmitting);
      }}
    >
      {({
        handleChange,
        values,
        errors,
        handleSubmit,
        setFieldValue,
        isSubmitting,
        setValues,
        setFieldTouched,
      }) => {
        return (
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />
            <form className="form-main" onSubmit={handleSubmit}>
              <div className="input-flex row">
                <div className="col-12">
                  <Input
                    handleChange={handleChange}
                    placeholder=" Enter the task name"
                    type="text"
                    label="Name"
                    value={values.name}
                    name="name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="name"
                      />
                    }
                  />
                </div>
                <div className="col-12">
                  <DateInput
                    isRequired
                    handleChange={(date) => {
                      setFieldValue("due_date", date);
                    }}
                    isValidDate={disablePastDates}
                    value={values.due_date}
                    label="Due Date"
                    name="due_date"
                    placeholder="Select due date"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="due_date"
                      />
                    }
                  />
                </div>
                <div className="col-sm-12">
                  <AsyncSelect
                    label="Assign To"
                    options={usersList.map((user) => ({
                      ...user,
                      label: `${user.name} \n    (${user.email})`,
                      value: user.id,
                    }))}
                    selectedValue={values.user_id}
                    placeholder="Select  "
                    handleChange={(option) => {
                      setFieldValue("user_id", option.value);
                    }}
                    dataCallback={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedFetchUsersData(inputValue, (options) => {
                          if (!options || options.length === 0) {
                            resolve([]);
                          } else {
                            resolve(options);
                          }
                        });
                      })
                    }
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="user_id"
                      />
                    }
                  />
                </div>
                <div className="col-12">
                  <Input
                    handleChange={handleChange}
                    placeholder="Enter any notes here"
                    type="text"
                    label="Notes"
                    value={values.description}
                    name="description"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="description"
                      />
                    }
                  />
                </div>
              </div>

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {isSubmitting ? (
                  <>
                    <span className="primary-btn w-50">
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </span>
                  </>
                ) : (
                  <input
                    className="primary-btn w-50"
                    type="submit"
                    name="submit"
                    value={isEditMode ? "Save Changes" : "Add Task"}
                  />
                )}
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddTaskForm;
